import styled from '@emotion/styled';

import CartButton from '../../../shared/button/CartButton';
import LikeButton from '../../../shared/button/LikeButton';
import RestockButton from '../../../shared/button/restock/RestockButton';

const ActionButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;
`;

const CartButtonWrapper = styled.div`
  flex-grow: 1;

  .cart-button {
    font-weight: 500;
  }
`;

interface Props {
  isActiveLike: boolean;
  isRestockNotificationAvailable: boolean;
  buyText: string;
  disabled: boolean;
  toggleLike(): void;
  onClickCartButton(): void;
}

export default function PurchaseButtonGroup({
  isActiveLike,
  isRestockNotificationAvailable,
  buyText,
  disabled,
  toggleLike,
  onClickCartButton,
}: Props) {
  return (
    <ActionButtonWrapper>
      <LikeButton
        isActiveLike={isActiveLike}
        toggleLike={toggleLike}
      />
      <RestockButton
        disabled={!isRestockNotificationAvailable}
      />
      <CartButtonWrapper>
        <CartButton
          text={buyText}
          onClick={onClickCartButton}
          disabled={disabled}
        />
      </CartButtonWrapper>
    </ActionButtonWrapper>
  );
}
